import { ReactNode } from 'react';
import ErrorView from './ErrorView';
import type { QueryState } from './GraphQLHelpers';
import LoadingView from './LoadingView';

interface QueryStateRendererProps<T> {
  state: QueryState<T>;
  children: (data: T) => ReactNode;
  loading?: ReactNode;
  error?: (error: Error) => ReactNode;
}

export default function QueryStateRenderer<T>({
  state,
  children,
  loading,
  error,
}: QueryStateRendererProps<T>): ReactNode {
  switch (state.status) {
    case 'loading':
      return loading ?? <LoadingView />;
    case 'error':
      return error ? error(state.error) : <ErrorView error={state.error} />;
    case 'success':
      return children(state.data);
  }
}
